<div *ngIf="lineItem" class="line-item-wrapper">
  <div class="line-item-row">
    <div class="line-item-column col-operating">
      <label>Operating From</label>
      <strong> {{ lineItem.fromPoint.displayName }} </strong>
      {{ lineItem.fromPoint.location.track.name }}
    </div>
    <div class="line-item-column col-track">
      <label>Operating To</label>
      <strong>{{lineItem.toPoint.displayName }}</strong>
      {{ lineItem.toPoint.location.track.name }}
    </div>
    <div *ngIf="lineItem.isUserCancelled" class="undo-action-wrapper undo-action-column">
      <div class="lock-icon">
        <span class="csx-common_lock">
          <span class="lock"> Line marked for Cancel</span>
        </span>
      </div>
      <div class="undo">
        <span class="undo-action" (click)="userClickedUndo()"> [Undo Action]</span>
      </div>
    </div>
  </div>
  <div class="line-item-row">
    <div *ngIf="lineItem.isUserCancelled || directionLock || line11Lock" class="line-item-column col-operating">
      <label> Direction </label>
      <strong>{{Direction[lineItem.direction]}} </strong>
    </div>
    <div *ngIf="!lineItem.isUserCancelled && !directionLock && !line11Lock" class="line-item-column col-operating">
      <label class="direction-label"> Direction </label>
      <p-dropdown [options]="directionListForModify" [(ngModel)]="lineItem.newDirection" class="test" [style]="{ 'margin-top': '0px' }"></p-dropdown>
    </div>

    <div class="line-item-column col-track">
      <label> Operate On </label>
      <strong>{{lineItem.operateOn }}</strong>
    </div>
  </div>
  <div *ngIf="directionLock && !line11Lock" class="direction-lock">
    <span class="csx-common_lock"> </span>Cannot modify Direction while performing Report By
  </div>
  <div *ngIf="line11Lock" class="direction-lock">
    <span class="csx-common_lock"> </span>Cannot modify Direction since Line 11 comments has word TRAIN
  </div>
</div>